import { MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

const indicators = [
  { id: 'experience', value: '20+', label: 'Années de pratique du vaudou' },
  { id: 'success', value: '97%', label: 'Taux de réussite annoncé' },
  { id: 'couples', value: '280', label: 'Clients satisfaits' },
  { id: 'results', value: '3–7j', label: 'Premiers résultats annoncés' },
];

export const ReasonsSection = ({ onContact }) => (
  <section data-testid="reasons-section" aria-labelledby="reasons-heading" className="border-y border-red-900/60 py-6 md:py-8">
    <h3 id="reasons-heading" data-testid="reasons-heading" className="text-lg font-bold text-white leading-relaxed text-center max-w-xl mx-auto">
      Pourquoi choisir le sorcier vaudou Maître Diamma ?
    </h3>
    <dl data-testid="reasons-statistics" className="grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-6 my-6 md:my-8 max-w-4xl mx-auto">
      {indicators.map(({ id, value, label }) => (
        <div key={id} data-testid={`reason-${id}`} className="min-w-0 border-l-2 border-red-900/60 pl-3 md:pl-5 flex flex-col">
          <dt className="order-2 text-sm text-gray-300 leading-relaxed max-w-40">{label}</dt>
          <dd data-testid={`reason-${id}-value`} className="order-1 text-[32px] font-bold tabular-nums text-yellow-400 leading-tight mb-2">{value}</dd>
        </div>
      ))}
    </dl>
    <div className="text-center">
      <Button data-testid="reasons-whatsapp-button" onClick={onContact} className="w-full max-w-xs h-auto py-3 px-4 bg-green-600 hover:bg-green-700 text-white font-semibold whitespace-normal">
        <MessageCircle className="w-5 h-5 mr-2 flex-shrink-0" aria-hidden="true" />
        Récupérer mon ex
      </Button>
      <p className="mt-3 text-gray-400 text-xs leading-relaxed">Consultation sur WhatsApp · Échanges confidentiels</p>
    </div>
  </section>
);